import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TE$ } from '@infl-ts/util-fp-ts';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
import * as t from 'io-ts';
import { HUB_API_URL } from '../env';
import { doAxiosReq, hasUnauthorizedCreds, HubConfig, logout, WindowObj } from './hub-axios-instance';

var getTokenTE = function getTokenTE(baseURL, cookie) {
  return pipe(doAxiosReq({
    method: 'POST',
    url: '/token',
    baseURL: baseURL,
    data: null,
    withCredentials: true,
    headers: {
      Accept: 'application/jwt',
      Cookie: cookie
    }
  }), TE.map(function (x) {
    return x.data;
  }), TE.chainEitherKW(flow(function (x) {
    return t.string.decode(x);
  }, E.mapLeft(makeDecodeError))));
};

var hubConfigTE = function hubConfigTE(baseURL, cookie, jwt) {
  return pipe(doAxiosReq({
    method: 'GET',
    url: '/api/company_config',
    baseURL: baseURL,
    withCredentials: true,
    headers: jwt ? {
      Accept: 'application/jwt',
      Cookie: null,
      Authorization: "Bearer ".concat(jwt)
    } : {
      Accept: 'application/jwt',
      Cookie: cookie
    }
  }), TE.map(function (x) {
    return x.data;
  }), TE.chainEitherKW(flow(function (x) {
    return HubConfig.decode(x);
  }, E.mapLeft(makeDecodeError))), TE.map(function (result) {
    return result.data.hub.id;
  }));
};

var getLanguageTE = function getLanguageTE(_ref) {
  var X_JWT_TOKEN = _ref.X_JWT_TOKEN,
      X_ORG_ID = _ref.X_ORG_ID;
  return pipe(doAxiosReq({
    method: 'GET',
    url: '/api/c2_homepage/infl_window_object',
    withCredentials: true,
    baseURL: HUB_API_URL,
    headers: {
      X_JWT_TOKEN: X_JWT_TOKEN,
      X_ORG_ID: X_ORG_ID
    }
  }), TE.map(function (x) {
    return x.data;
  }), TE.chainEitherKW(flow(function (x) {
    return WindowObj.decode(x);
  }, E.mapLeft(makeDecodeError))), TE.map(function (x) {
    return x.hub.lang;
  }));
};

export var getHeaders = function getHeaders(_ref2) {
  var currentHubURL = _ref2.currentHubURL,
      cookie = _ref2.cookie,
      jwt = _ref2.jwt;
  return pipe(TE.Do, TE.apSW('X_JWT_TOKEN', jwt ? TE.of(jwt) : getTokenTE(currentHubURL, cookie)), TE.apSW('X_ORG_ID', hubConfigTE(currentHubURL, cookie, jwt)), TE.bind('Accept-Language', getLanguageTE));
};
export var noMemoRequest = function noMemoRequest(_ref3) {
  var config = _ref3.config,
      currentHubURL = _ref3.currentHubURL,
      cookie = _ref3.cookie,
      jwt = _ref3.jwt,
      _ref3$shouldLogOut = _ref3.shouldLogOut,
      shouldLogOut = _ref3$shouldLogOut === void 0 ? false : _ref3$shouldLogOut;
  return pipe(getHeaders({
    currentHubURL: currentHubURL,
    cookie: cookie,
    jwt: jwt
  }), TE.map(function (headers) {
    return _objectSpread(_objectSpread({}, config), {}, {
      baseURL: HUB_API_URL,
      headers: _objectSpread(_objectSpread({}, config.headers), headers)
    });
  }), TE.chain(doAxiosReq), TE.orElseFirstW(function (e) {
    return e._tag === 'axios' && e.error.response && hasUnauthorizedCreds(e.error.response) && shouldLogOut ? TE.rightIO(function () {
      return void logout();
    }) : TE$.unit;
  }));
};